import { Injectable } from '@angular/core';

import { decodeJwt } from '@libs/src/utilities/jwt.utilities';

@Injectable({ providedIn: 'root' })
export class JwtService {
  decodeJwt(token: string) {
    return decodeJwt(token);
  }
}
